import { createEffect, createEvent, createStore } from "effector"
import { API } from "../API"
import { IUserItem } from "../types/Item"


export const getUserItems = createEffect(async()=>{
    const res = await API.user.getCollection()

    return res
})

export const clearUserItems = createEvent()
export const $userItems = createStore<IUserItem[]>([])
.on(getUserItems.doneData,(state,res)=> [...state,...res.toys_collected])
.on(clearUserItems,()=>[])